module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_0.d4ec4de2.png";